import React from "react";
import { useTranslation } from "react-i18next";
import { WheelCanvas } from "./WheelCanvas";
import { WheelPin } from "./WheelPin";
import {
  useRaffleWheelRotation,
  useRaffleWheelStatic,
} from "./RaffleWheelContext";
import cls from "./styles.module.scss";

export const WheelSurface = () => {
  const { t } = useTranslation();
  const { normalWheelSize, wheelSize } = useRaffleWheelStatic();
  const { rotation } = useRaffleWheelRotation();

  return (
    <div className={cls.root}>
      <div
        className={cls.wheelWrap}
        style={{
          width: `${normalWheelSize}px`,
          height: `${normalWheelSize}px`,
        }}
      >
        <div
          className={cls.wheel}
          style={
            {
              width: `${wheelSize}px`,
            } as React.CSSProperties
          }
          aria-label={t("raffle.a11y.participantsWheel")}
        >
          <div
            className={cls.canvasWrap}
            style={{ transform: `rotate(${rotation}deg)` }}
          >
            <WheelCanvas />
          </div>
          <WheelPin />
        </div>
      </div>
    </div>
  );
};
